import { TrustpilotCarousel } from 'components/TrustpilotCarousel'
import { useMemoizedContentGetter, useInlineMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import SectionContainer from 'components/Section/SectionContainer'
import { TitleDivider } from 'components/TitleDivider'
import { useEffect, useRef } from 'react'
import useSearchParamChecker from 'utils/queryManipulation/useSearchParamChecker'

const TrustpilotCarouselSection = ({ content }) => {
  const isDisabledParamPresent = useSearchParamChecker('disableFeatures', 'trustpilot_carousel')
  const ref = useRef(null)

  useEffect(() => {
    if (window.Trustpilot && !isDisabledParamPresent) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [isDisabledParamPresent])

  const {
    config,
    eyebrow,
    subtitle,
    title,
  } = useMemoizedContentGetter(content, [
    'config',
    'eyebrow',
    'subtitle',
    'title',
  ])

  const { jsonContent } = useInlineMemoizedContentGetter(content.fields?.additionalConfiguration, [
    'jsonContent',
  ])

  if (isDisabledParamPresent || isDisabledParamPresent == null) return null

  const trustpilotCarouselConfig = config?.jsonContent || {}
  return (
    <Section
      data-testid="trustpilot-carousel-section"
      contain={false}
      defaultPadY
      sectionStyles={jsonContent?.style ?? null}
    >
      <SectionContainer>
        {title &&
          <TitleDivider
            className="mb-6"
            eyebrow={eyebrow}
            eyebrowBlack
            subtitle={subtitle}
            title={title}
          />
        }
      </SectionContainer>

      <TrustpilotCarousel reference={ref} {...trustpilotCarouselConfig} />
    </Section>
  )
}

export { TrustpilotCarouselSection }
export default TrustpilotCarouselSection
